// src/utils/reporteProveedoresGenerator.js

// 👈 NUEVO: Importar función que obtiene los datos de la empresa actual
import { obtenerDatosEmpresa } from './tenantConfig';

// Configuración por defecto (fallback)
export const SYSTEM_JJ_CONFIG = {
  nombre: "SYSTEM JJ",
  rif: "J-41023119-0",
  direccion: "C.C. LATIN CENTER PB LOCAL 01",
  telefono: "0416-7594723",
  whatsapp: "04167594723",
  ciudad: "ACARIGUA - PORTUGUESA",
  email: "soporte@systemjj.com",
  sitioWeb: "www.systemjj.com",
  slogan: "Servicio Técnico Especializado",
  lema: "Tecnología al servicio de la gente"
};

/**
 * 👈 NUEVO: Obtiene la config de la empresa actual con fallback
 */
const getEmpresa = () => {
  try {
    const datos = obtenerDatosEmpresa();
    return {
      nombre: datos.nombreComercial || datos.nombre || SYSTEM_JJ_CONFIG.nombre,
      rif: datos.rif || SYSTEM_JJ_CONFIG.rif,
      direccion: datos.direccion || SYSTEM_JJ_CONFIG.direccion,
      telefono: datos.telefono1 || datos.telefono2 || SYSTEM_JJ_CONFIG.telefono,
      whatsapp: datos.whatsapp || datos.telefono1 || SYSTEM_JJ_CONFIG.whatsapp,
      ciudad: datos.ciudad || SYSTEM_JJ_CONFIG.ciudad,
      email: datos.email || SYSTEM_JJ_CONFIG.email,
      sitioWeb: datos.sitioWeb || SYSTEM_JJ_CONFIG.sitioWeb,
      slogan: datos.slogan || SYSTEM_JJ_CONFIG.slogan,
      lema: datos.slogan || SYSTEM_JJ_CONFIG.lema,
      logoBase64: datos.logoBase64 || null,
    };
  } catch (err) {
    console.warn('⚠️ No se pudo obtener config del tenant, usando fallback:', err);
    return { ...SYSTEM_JJ_CONFIG, logoBase64: null };
  }
};

// Variable para el logo en base64
let LOGO_BASE64 = '';

/**
 * 👈 MODIFICADO: Prioriza el logo del tenant; si no hay, usa /jj.png
 */
export const cargarLogo = async () => {
  try {
    const empresa = getEmpresa();
    if (empresa.logoBase64) {
      const base64Limpio = empresa.logoBase64.includes(',')
        ? empresa.logoBase64.split(',')[1]
        : empresa.logoBase64;
      LOGO_BASE64 = base64Limpio;
      console.log('✅ Logo del tenant cargado (proveedores)');
      return LOGO_BASE64;
    }

    const response = await fetch('/jj.png');
    const blob = await response.blob();
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        LOGO_BASE64 = reader.result.split(',')[1];
        resolve(LOGO_BASE64);
      };
      reader.onerror = () => {
        LOGO_BASE64 = '';
        resolve('');
      };
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    console.error('Error cargando el logo:', error);
    LOGO_BASE64 = '';
    return '';
  }
};

export const getLogoBase64 = () => LOGO_BASE64;

// ==================== UTILIDADES ====================

export const formatearFechaReporte = (fechaISO) => {
  if (!fechaISO) return 'No disponible';
  try {
    const fecha = new Date(fechaISO);
    return fecha.toLocaleDateString('es-VE', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  } catch {
    return fechaISO;
  }
};

export const formatearFechaCorta = (fechaISO) => {
  if (!fechaISO) return 'No disponible';
  try {
    const fecha = new Date(fechaISO);
    return fecha.toLocaleDateString('es-VE', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  } catch {
    return fechaISO;
  }
};

export const formatearNumero = (numero, decimales = 2) => {
  if (numero === null || numero === undefined) return '0.00';
  return new Intl.NumberFormat('es-VE', {
    minimumFractionDigits: decimales,
    maximumFractionDigits: decimales
  }).format(numero);
};

export const formatearMonedaUSD = (monto) => {
  if (monto === null || monto === undefined) return '$0.00';
  return `$${formatearNumero(monto, 2)}`;
};

export const convertirEstadoTexto = (estado) => {
  if (!estado) return 'DESCONOCIDO';
  const estadoLower = estado.toString().toLowerCase();
  if (estadoLower === 'activo' || estadoLower === 'true' || estadoLower === '1') return 'ACTIVO';
  if (estadoLower === 'inactivo' || estadoLower === 'false' || estadoLower === '0') return 'INACTIVO';
  return estado.toString().toUpperCase();
};

export const getBadgeEstado = (estado) => {
  const estadoTexto = convertirEstadoTexto(estado);
  return {
    texto: estadoTexto,
    clase: estadoTexto === 'ACTIVO' ? 'estado-activo' : 'estado-inactivo'
  };
};

export const formatearRIF = (rif) => {
  if (!rif) return 'N/A';
  if (rif.length > 2 && !rif.includes('-')) {
    return `${rif.charAt(0)}-${rif.substring(1, rif.length - 1)}-${rif.charAt(rif.length - 1)}`;
  }
  return rif;
};

export const formatearTelefono = (telefono) => {
  if (!telefono) return 'N/A';
  const cleaned = telefono.replace(/\D/g, '');
  if (cleaned.length === 11) {
    return `(${cleaned.substring(0, 4)}) ${cleaned.substring(4, 7)}-${cleaned.substring(7)}`;
  }
  if (cleaned.length === 10) {
    return `(${cleaned.substring(0, 3)}) ${cleaned.substring(3, 6)}-${cleaned.substring(6)}`;
  }
  return telefono;
};

// ==================== CÁLCULOS ====================

export const calcularEstadisticasReporte = (proveedores) => {
  const total = proveedores.length;
  const activos = proveedores.filter(p => 
    p.estado?.toLowerCase() === 'activo'
  ).length;
  
  const inactivos = total - activos;
  const porcentajeActivos = total > 0 ? Math.round((activos / total) * 100) : 0;
  const porcentajeInactivos = total > 0 ? Math.round((inactivos / total) * 100) : 0;
  
  const conTelefono = proveedores.filter(p => p.telefono && p.telefono.trim() !== '').length;
  const conEmail = proveedores.filter(p => p.email && p.email.trim() !== '').length;
  const conDireccion = proveedores.filter(p => p.direccion && p.direccion.trim() !== '').length;
  
  const tiposMap = {};
  proveedores.forEach(proveedor => {
    const tipo = proveedor.tipoProveedor || 'Sin Tipo';
    if (!tiposMap[tipo]) {
      tiposMap[tipo] = { nombre: tipo, total: 0 };
    }
    tiposMap[tipo].total++;
  });
  
  const especialidadesMap = {};
  proveedores.forEach(proveedor => {
    if (proveedor.especialidad) {
      const especialidad = proveedor.especialidad;
      if (!especialidadesMap[especialidad]) {
        especialidadesMap[especialidad] = { nombre: especialidad, total: 0 };
      }
      especialidadesMap[especialidad].total++;
    }
  });
  
  const totalProductos = proveedores.reduce((sum, p) => sum + (Number(p.totalProductos) || 0), 0);
  const totalCompras = proveedores.reduce((sum, p) => sum + (Number(p.totalCompras) || 0), 0);
  const promedioProductos = total > 0 ? Math.round(totalProductos / total) : 0;
  const promedioCompras = total > 0 ? Math.round(totalCompras / total) : 0;
  
  return {
    total,
    activos,
    inactivos,
    porcentajeActivos,
    porcentajeInactivos,
    conTelefono,
    conEmail,
    conDireccion,
    totalProductos,
    totalCompras,
    promedioProductos,
    promedioCompras,
    tipos: Object.values(tiposMap).sort((a, b) => b.total - a.total),
    especialidades: Object.values(especialidadesMap).sort((a, b) => b.total - a.total)
  };
};

export const filtrarProveedoresParaReporte = (proveedores, filtro, tipo = null) => {
  let proveedoresFiltrados = [...proveedores];
  
  switch (filtro) {
    case 'todos':
      break;
    case 'activos':
      proveedoresFiltrados = proveedoresFiltrados.filter(p => 
        p.estado?.toLowerCase() === 'activo'
      );
      break;
    case 'inactivos':
      proveedoresFiltrados = proveedoresFiltrados.filter(p => 
        p.estado?.toLowerCase() === 'inactivo'
      );
      break;
    case 'con_contacto':
      proveedoresFiltrados = proveedoresFiltrados.filter(p => 
        (p.telefono && p.telefono.trim() !== '') || (p.email && p.email.trim() !== '')
      );
      break;
    case 'sin_contacto':
      proveedoresFiltrados = proveedoresFiltrados.filter(p => 
        (!p.telefono || p.telefono.trim() === '') && (!p.email || p.email.trim() === '')
      );
      break;
    default:
      break;
  }
  
  if (tipo && tipo !== 'todos') {
    proveedoresFiltrados = proveedoresFiltrados.filter(p => 
      p.tipoProveedor === tipo
    );
  }
  
  return proveedoresFiltrados;
};

// ==================== GENERAR HTML ====================

export const generarHTMLReporteProveedores = (proveedores, titulo = null, filtro = 'todos', tipo = null) => {
  const empresa = getEmpresa();   // 👈 NUEVO: datos dinámicos del tenant
  const fechaActual = new Date();
  const estadisticas = calcularEstadisticasReporte(proveedores);
  
  let tituloReal = titulo;
  if (!tituloReal) {
    const titulosPorFiltro = {
      'todos': 'REPORTE GENERAL DE PROVEEDORES',
      'activos': 'PROVEEDORES ACTIVOS',
      'inactivos': 'PROVEEDORES INACTIVOS',
      'con_contacto': 'PROVEEDORES CON DATOS DE CONTACTO',
      'sin_contacto': 'PROVEEDORES SIN DATOS DE CONTACTO'
    };
    tituloReal = titulosPorFiltro[filtro] || 'REPORTE DE PROVEEDORES';
  }
  
  if (tipo && tipo !== 'todos') {
    tituloReal += ` - TIPO: ${tipo.toUpperCase()}`;
  }

  return `<!DOCTYPE html>
<html lang="es">
<head>
  <meta charset="UTF-8">
  <title>${tituloReal} - ${empresa.nombre}</title>
  <style>
    * { margin: 0; padding: 0; box-sizing: border-box; }
    body {
      font-family: 'Arial', 'Helvetica', sans-serif;
      background: white;
      padding: 15px;
    }
    .reporte { max-width: 1200px; margin: 0 auto; }
    
    .header {
      padding: 10px 0;
      border-bottom: 1px solid #000;
      margin-bottom: 15px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .logo-area { display: flex; align-items: center; gap: 10px; }
    .logo-img { height: 45px; width: auto; object-fit: contain; }
    .empresa-nombre { font-size: 16px; font-weight: bold; }
    .empresa-slogan { font-size: 9px; color: #666; }
    .rif-info { text-align: right; font-size: 9px; line-height: 1.3; }
    
    .titulo { padding: 8px 0; }
    .titulo h1 { font-size: 16px; font-weight: bold; }
    .fecha { font-size: 9px; color: #666; margin-top: 3px; }
    
    .stats-bar {
      background: #f8f8f8;
      padding: 6px 12px;
      margin: 10px 0;
      border: 1px solid #e0e0e0;
      font-size: 11px;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      gap: 15px;
    }
    .stat-item-compact {
      display: inline-flex;
      align-items: baseline;
      gap: 4px;
    }
    .stat-label-compact {
      font-weight: normal;
      color: #666;
    }
    .stat-valor-compact {
      font-weight: bold;
      color: #000;
    }
    
    .tabla-container { overflow-x: auto; }
    table {
      width: 100%;
      border-collapse: collapse;
      font-size: 9px;
      border: 1px solid #ddd;
    }
    th {
      background: #f5f5f5;
      padding: 6px 4px;
      text-align: left;
      font-weight: bold;
      border-bottom: 1px solid #ddd;
    }
    td {
      padding: 5px 4px;
      border-bottom: 1px solid #eee;
    }
    tr:hover td { background: #fafafa; }
    .text-right { text-align: right; }
    .text-center { text-align: center; }
    
    .badge-activo {
      background: #d4edda;
      color: #155724;
      padding: 2px 6px;
      border-radius: 10px;
      font-size: 8px;
      font-weight: bold;
    }
    .badge-inactivo {
      background: #f8d7da;
      color: #721c24;
      padding: 2px 6px;
      border-radius: 10px;
      font-size: 8px;
      font-weight: bold;
    }
    
    .controles {
      text-align: center;
      margin-top: 15px;
      padding: 10px;
      background: #f5f5f5;
    }
    button {
      padding: 6px 15px;
      font-size: 10px;
      margin: 0 3px;
      cursor: pointer;
      border: 1px solid #ccc;
      background: white;
    }
    button:hover { background: #f0f0f0; }
    
    @media print {
      body { padding: 0; }
      .controles { display: none; }
      @page { margin: 1cm; size: landscape; }
    }
  </style>
</head>
<body>
<div class="reporte">
  <div class="header">
    <div class="logo-area">
      ${getLogoBase64() ? `<img src="data:image/jpeg;base64,${getLogoBase64()}" class="logo-img" onerror="this.style.display='none'">` : ''}
      <div>
        <div class="empresa-nombre">${empresa.nombre}</div>
        <div class="empresa-slogan">${empresa.slogan}</div>
      </div>
    </div>
    <div class="rif-info">
      RIF: ${empresa.rif}<br>
      ${empresa.ciudad}
    </div>
  </div>
  
  <div class="titulo">
    <h1>${tituloReal}</h1>
    <div class="fecha">${formatearFechaReporte(fechaActual.toISOString())}</div>
  </div>
  
  <div class="stats-bar">
    <div class="stat-item-compact"><span class="stat-label-compact">Total:</span><span class="stat-valor-compact">${estadisticas.total}</span></div>
    <div class="stat-item-compact"><span class="stat-label-compact">Activos:</span><span class="stat-valor-compact">${estadisticas.activos}</span></div>
    <div class="stat-item-compact"><span class="stat-label-compact">Inactivos:</span><span class="stat-valor-compact">${estadisticas.inactivos}</span></div>
    <div class="stat-item-compact"><span class="stat-label-compact">Con Teléfono:</span><span class="stat-valor-compact">${estadisticas.conTelefono}</span></div>
    <div class="stat-item-compact"><span class="stat-label-compact">Con Email:</span><span class="stat-valor-compact">${estadisticas.conEmail}</span></div>
  </div>
  
  <div class="tabla-container">
    ${proveedores.length > 0 ? `
    <table>
      <thead>
        <tr>
          <th>Código</th>
          <th>Nombre</th>
          <th>RIF</th>
          <th>Teléfono</th>
          <th>Email</th>
          <th>Contacto</th>
          <th>Tipo</th>
          <th>Especialidad</th>
          <th>Estado</th>
          <th class="text-right">Productos</th>
          <th class="text-right">Compras</th>
        </tr>
      </thead>
      <tbody>
        ${proveedores.map(p => `
          <tr>
            <td><strong>${p.idProveedor || '—'}</strong></td>
            <td>${p.nombre || '—'}</td>
            <td>${formatearRIF(p.rif)}</td>
            <td>${formatearTelefono(p.telefono)}</td>
            <td>${p.email || '—'}</td>
            <td>${p.contacto || '—'}</td>
            <td>${p.tipoProveedor || '—'}</td>
            <td>${p.especialidad || '—'}</td>
            <td class="text-center"><span class="${p.estado?.toLowerCase() === 'activo' ? 'badge-activo' : 'badge-inactivo'}">${convertirEstadoTexto(p.estado)}</span></td>
            <td class="text-right">${p.totalProductos || 0}</td>
            <td class="text-right">${p.totalCompras || 0}</td>
          </tr>
        `).join('')}
      </tbody>
      <tfoot>
        <tr style="background: #f5f5f5;">
          <td colspan="9" class="text-right"><strong>TOTALES:</strong></td>
          <td class="text-right"><strong>${estadisticas.totalProductos}</strong></td>
          <td class="text-right"><strong>${estadisticas.totalCompras}</strong></td>
        </tr>
      </tfoot>
    </table>
    ` : '<div style="padding: 30px; text-align: center; border: 1px solid #ddd;">No hay proveedores para mostrar</div>'}
  </div>
</div>

<div class="controles">
  <button onclick="window.print()">🖨️ IMPRIMIR</button>
  <button onclick="window.close()">✖️ CERRAR</button>
</div>
</body>
</html>`;
};

// ==================== IMPRIMIR ====================

export const imprimirReporteProveedores = async (proveedores, titulo = null, filtro = 'todos', tipo = null) => {
  if (!proveedores || proveedores.length === 0) {
    alert('No hay proveedores para mostrar');
    return false;
  }
  
  try {
    // Resetear logo para que se recargue el del tenant actual
    LOGO_BASE64 = '';
    await cargarLogo();

    const htmlReporte = generarHTMLReporteProveedores(proveedores, titulo, filtro, tipo);
    const ventana = window.open('', '_blank', 'width=1200,height=700,menubar=yes,toolbar=yes,scrollbars=yes');
    
    if (!ventana) {
      alert('Por favor, permite ventanas emergentes');
      return false;
    }
    
    ventana.document.write(htmlReporte);
    ventana.document.close();
    ventana.focus();
    return true;
  } catch (error) {
    console.error('Error:', error);
    alert('Error al generar el reporte');
    return false;
  }
};

export const imprimirReporteProveedoresSimplificado = async (proveedores, titulo = null) => {
  return imprimirReporteProveedores(proveedores, titulo, 'todos', null);
};

export default {
  SYSTEM_JJ_CONFIG,
  cargarLogo,
  getLogoBase64,
  formatearFechaReporte,
  formatearFechaCorta,
  formatearNumero,
  formatearMonedaUSD,
  convertirEstadoTexto,
  getBadgeEstado,
  formatearRIF,
  formatearTelefono,
  calcularEstadisticasReporte,
  filtrarProveedoresParaReporte,
  generarHTMLReporteProveedores,
  imprimirReporteProveedores,
  imprimirReporteProveedoresSimplificado
};